import { useIntl } from 'react-intl';

interface IAvailableInBadgeProps {
  isCovered: boolean;
  availableIn?: string;
}

export const CoverageAvailableInBadge = ({isCovered, availableIn}: IAvailableInBadgeProps) => {
  const intl = useIntl();
  
  const getBadge = () => {
    if (!isCovered && availableIn ) {
      return (
        <div className="label label-muted rounded-circle text-bold">
          <span className='rioglyph rioglyph-time-alt margin-right-5 text-color-dark'></span>
          <span className="text-bold  text-color-dark">{availableIn}</span>
        </div>
      )
    }

    if(isCovered) {
      return (
        <div className="label label-success rounded-circle">
          <span className="rioglyph rioglyph-ok margin-right-5">
          </span>
          <span>{intl.formatMessage({ id: 'intl-msg:budgets.availableIn' })}</span>
        </div>
      )
    }

    return '-'
  }

  return getBadge()
}